import {
  CONDITIONAL_UI_SCHEMA_KEY,
  FIELD_ORDER_UI_SCHEMA_KEY,
  ShapeUISchema,
} from '../../StepConfigEditorTypes';

/**
 * Creates a conditional UI schema section for a specific chart type.
 *
 * This helper wraps chart-specific configuration or style sections with the
 * CONDITIONAL_UI_SCHEMA_KEY to ensure they only render when the matching
 * chart type is selected.
 *
 * The section order is determined by the FIELD_ORDER_UI_SCHEMA_KEY defined in the sections object.
 *
 * @param chartType - The chart type identifier (e.g., 'BOX_PLOT', 'PIE_CHART')
 * @param sections - The sections to include in the schema (must include FIELD_ORDER_UI_SCHEMA_KEY)
 * @returns A ShapeUISchema with conditional rendering based on chart type
 *
 * @example
 * const boxPlotConfig = createChartTypeSchema('BOX_PLOT', BOX_PLOT_CONFIG_SECTIONS);
 */
export function createChartTypeSchema<T extends {[FIELD_ORDER_UI_SCHEMA_KEY]: ReadonlyArray<string>}>(
  chartType: string,
  sections: T
): ShapeUISchema {
  return {
    [CONDITIONAL_UI_SCHEMA_KEY]: {
      tagValue: chartType,
      configShapePath: ['chartConfig', 'type'],
    },
    ...sections,
  } as ShapeUISchema;
}
